import { get } from 'lodash'

import { Colors, Services, getPrice, isEmpty, joinURLPath } from '@sigma-frontend-libs/commons'
import { BILLING_STATUS } from '@sigma-legacy-libs/essentials/lib/constants'

import { permissionPresets, request } from '@/utils'

import render from './render'

export default {
  name: 'Price',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      billings: [],
      timeoutsRegistry: new Map()
    }
  },

  computed: {
    providerAmount() {
      return get(this.value, 'meta.billing.providerAmount') || get(this.value, `meta.${Services.billings}.provider.amount`)
    },
    hasProviderAmount() {
      return !isEmpty(this.providerAmount) && this.checkPermissions(`advanced.${Services.sendings}.get`, permissionPresets.managerUp)
    },

    tooltip() {
      const result = [ this.getTranslate(`${Services.sendings}.tooltips.price`) ]
      if (this.hasProviderAmount && !isNaN(this.providerAmount)) {
        result.push(`${this.getTranslate(`${Services.sendings}.hints.purchase`)}: ${getPrice(this.providerAmount)}`)
      }
      if (this.refunded) {
        result.push(this.getTranslate(`${Services.billings}.statuses.${BILLING_STATUS.refunded}`))
      }

      return result.join('\n')
    },

    billingAmount() {
      return this.billings.reduce((sum, { amount }) => {
        if (sum === undefined) {
          sum = 0
        }

        sum += parseFloat(amount)

        if (isNaN(sum)) {
          sum = undefined
        }

        return sum
      }, undefined)
    },

    refunded() {
      return get(this.value, 'meta.billing.refunded') || this.billings.length && this.billings.every(({ status }) => {
        return status === BILLING_STATUS.refunded
      })
    },

    color() {
      if (this.refunded) {
        return Colors.grey
      }

      if (this.hasProviderAmount) {
        switch (true) {
          case this.providerAmount < this.billingAmount: return Colors.error
          case this.providerAmount > this.billingAmount: return Colors.success
          case this.providerAmount == this.billingAmount:
          default: return Colors.primary
        }
      }

      return Colors.black
    },

    ids() {
      return get(this.value, 'meta.billings.ids', [ get(this.value, 'meta.billing.id') ])
    }
  },

  mounted() {
    this.get()
  },

  beforeDestroy() {
    this.clearAllTimeouts()
  },

  methods: {
    scheduleRetry(id) {
      this.clearTimeoutById(id)
      const timeoutId = setTimeout(() => {
        return this.get()
      }, 5 * 1000)
      this.timeoutsRegistry.set(id, timeoutId)
    },

    clearTimeoutById(id) {
      if (!this.timeoutsRegistry) {
        return
      }

      const timeoutId = this.timeoutsRegistry.get(id)
      if (!timeoutId) {
        return
      }

      clearTimeout(timeoutId)
      this.timeoutsRegistry.delete(id)
    },

    clearAllTimeouts() {
      if (!this.timeoutsRegistry) {
        return
      }

      this.timeoutsRegistry.forEach(timeoutId => {
        clearTimeout(timeoutId)
      })
      this.timeoutsRegistry.clear()
    },

    async get() {
      if (this.ids.length) {
        for (const id of this.ids) {
          try {
            const data = await request.get(joinURLPath(Services.billings, id))
            if (data?.id) {
              const index = this.billings.findIndex(item => {
                return item.id === data.id
              })
              if (index >= 0) {
                this.billings.splice(index, 1, data)
              } else {
                this.billings.push(data)
              }
            }
            this.clearTimeoutById(id)
          } catch (error) {
            this.scheduleRetry(id)
          }
        }
      }
    }
  },

  render
}
